// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Stdlib = require("@rescript/runtime/lib/js/Stdlib.js");
let AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let BuyerNeedAreas = require("../BuyerNeedAreas.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let BuyerNeed__Status = require("../../qa/AllInBuyerNeed/BuyerNeed__Status.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let BuyerNeedPriceRange = require("../BuyerNeedPriceRange.bs.js");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BuyerNeedPropertyAttributes = require("../BuyerNeedPropertyAttributes.bs.js");
let ClientNeedSearchResultTimestamp = require("./ClientNeedSearchResultTimestamp.bs.js");
let BuyerNeedSearchResult_buyerNeed_graphql = require("../../../__generated__/BuyerNeedSearchResult_buyerNeed_graphql.bs.js");
let BuyerNeedSearchResultTimestamp_buyerNeed_graphql = require("../../../__generated__/BuyerNeedSearchResultTimestamp_buyerNeed_graphql.bs.js");

let convertFragment = BuyerNeedSearchResult_buyerNeed_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedSearchResult_buyerNeed_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedSearchResult_buyerNeed_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerNeedSearchResult_buyerNeed_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedSearchResult_buyerNeed_graphql.node, convertFragment, fRef);
}

let BuyerNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = BuyerNeedSearchResultTimestamp_buyerNeed_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedSearchResultTimestamp_buyerNeed_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedSearchResultTimestamp_buyerNeed_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerNeedSearchResultTimestamp_buyerNeed_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedSearchResultTimestamp_buyerNeed_graphql.node, convertFragment$1, fRef);
}

let BuyerNeedFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function BuyerNeedSearchResult$Timestamp$WithoutErrorBoundary(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(BuyerNeedSearchResultTimestamp_buyerNeed_graphql.node, convertFragment$1, props.buyerNeed);
  let v = Stdlib_Option.map(Stdlib_Array.keepSome(buyerNeed.broadcasts.edges)[0], e => e.node.broadcastAt);
  let broadcastAt = v !== undefined ? Primitive_option.valFromOption(v) : Stdlib.panic("Missing `broadcastAt`.");
  return JsxRuntime.jsx(ClientNeedSearchResultTimestamp.make, {
    updatedAt: buyerNeed.updatedAt,
    broadcastAt: broadcastAt
  });
}

let WithoutErrorBoundary = {
  make: BuyerNeedSearchResult$Timestamp$WithoutErrorBoundary
};

function BuyerNeedSearchResult$Timestamp(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "buyer need search result timestamp",
    children: JsxRuntime.jsx(BuyerNeedSearchResult$Timestamp$WithoutErrorBoundary, {
      buyerNeed: props.buyerNeed
    })
  });
}

let Timestamp = {
  BuyerNeedFragment: BuyerNeedFragment$1,
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: BuyerNeedSearchResult$Timestamp
};

function BuyerNeedSearchResult(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(BuyerNeedSearchResult_buyerNeed_graphql.node, convertFragment, props.buyerNeed);
  let isMobile = MediaQuery.isMobile();
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(BuyerNeedPriceRange.make, {
                    buyerNeed: buyerNeed.fragmentRefs,
                    size: "medium"
                  }),
                  className: "flex-1"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(BuyerNeed__Status.make, {
                    buyerNeed: buyerNeed.fragmentRefs
                  })
                })
              ],
              className: "flex flex-row justify-between mb-4"
            }),
            JsxRuntime.jsx("div", {
              children: Stdlib_Option.getOr(buyerNeed.headline, ""),
              className: "text-xl mt-2 line-clamp-2"
            })
          ]
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(BuyerNeedAreas.make, {
                buyerNeed: buyerNeed.fragmentRefs
              }),
              className: "mt-6"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(BuyerNeedPropertyAttributes.make, {
                buyerNeed: buyerNeed.fragmentRefs
              }),
              className: "mt-4"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(AgentInfo.make, {
                agent: buyerNeed.agent.fragmentRefs
              }),
              className: "mt-8"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(BuyerNeedSearchResult$Timestamp, {
                buyerNeed: buyerNeed.fragmentRefs
              }),
              className: "mt-4"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                href: "/client_needs/" + buyerNeed.id,
                size: "small",
                className: "flex-1 justify-center",
                children: JsxRuntime.jsxs(ViewStack.make, {
                  space: "xs",
                  flexDirection: "row",
                  children: [
                    JsxRuntime.jsx(IconV5.make, {
                      icon: "view-details"
                    }),
                    JsxRuntime.jsx("div", {
                      children: isMobile ? JsxRuntime.jsx(VisuallyHidden, {
                          children: "View Details"
                        }) : "View Details"
                    })
                  ]
                })
              }),
              className: "mt-4 flex"
            })
          ]
        })
      ],
      className: "flex flex-col justify-between h-full"
    }),
    className: "bg-white rounded-md border p-4 hover:shadow-lg"
  });
}

let make = BuyerNeedSearchResult;

exports.BuyerNeedFragment = BuyerNeedFragment;
exports.Timestamp = Timestamp;
exports.make = make;
/* IconV5 Not a pure module */
